import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { assignmentScores, spendingsData, timeOnSiteData, personalData } from '../Data';

import PageHeader from './PageHeader';

import Spendings from './Spendings';
import StudentInfo from './StudentInfo';
import TimeOnSite from './TimeOnSite';
import AssignmentScores from './AssignmentScores';

const Analitycs = () => {
 return (
  <>
   <PageHeader type={personalData.cargo} name={`${personalData.name}  ${personalData.lastnames}`} />
   <Row className="g-3 mb-3">
    <Col xxl={6}>
     <Row className="g-3">
      <Col xs={12}>
       <StudentInfo data={personalData} />
      </Col>
      <Col md={6}>
       <Spendings data={spendingsData} />
      </Col>
      <Col md={6}>
       <TimeOnSite data={timeOnSiteData} />
      </Col>
     </Row>
    </Col>
    <Col xxl={6}>
     <AssignmentScores scoresData={assignmentScores} />
    </Col>
   </Row>
  </>
 );
};

export default Analitycs;
